export default __webpack_public_path__ + "static/media/pw-add-form-4.18fbc945.jpg";